<template>
  <table v-bind="$attrs" class="border-collapse">
    <thead>
      <slot name="table-header"></slot>
    </thead>
    <tbody>
      <slot name="table-body"></slot>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'AppTable',
}
</script>
